angular
	.module 'App.Repository'

.factory 'GiftcardReportRepository', ['BaseRepository', (BaseRepository) ->
	class GiftcardReportRepository extends BaseRepository
		@resource = '/reports'
		@isRestricted = true

		getCardsReport: (query) ->
			return @find('giftcards', query)

		getTypesReport: (query) ->
			return @find('voucher_types', query)

	return new GiftcardReportRepository
]
